





























import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
import { Account, fetchAccountWithoutRedirect } from 'ykd-base/account'
import { State, Action, namespace, Mutation } from 'vuex-class'
import { getPartnerAccount } from '@/api/coupon/partner'
import PartnerData, {
  WorkOrderSubmitParam,
  WorkOrder
} from '@/model/coupon/partnerData'
import { jumpToLogin } from 'ykd-base/login'

const ModuleUser = namespace('app-sandwich/user')
@Component({
  components: {}
})
export default class Partner extends Vue {
  @ModuleUser.State(state => state.isLogin) private isLogin!: boolean
  @Prop() private workOrder?: WorkOrder
  async mounted() {
    const account = await getPartnerAccount()
    if (account) {
      this.$router.push({ path: '/coupon/home/partner' })
    }
  }
}
